export default __webpack_public_path__ + "static/avatar-kayi-common-0-cover-3e11836f98c8391f9f944fe4ae49e656.png";